/*! License details at fancyapps.com/license */
var n = function n() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return n.split(t).join(o);
};
export { n as replaceAll };